import React, { Component, PureComponent } from "react";
import Moment from "react-moment";
import moment from "moment";
import escapeRegExp from "escape-string-regexp";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faDesktop, faStoreAlt, faUpload, faUser, faIndustry, faInfoCircle, faCalendar, faAsterisk, faBoxes, faUniversity } from "@fortawesome/free-solid-svg-icons";
import {
  Table,
  DropdownToggle,
  DropdownMenu, Button, Tooltip,  Dropdown,
  Pagination, PaginationItem, PaginationLink
} from "reactstrap";

import { getIvuTrans, getAuthorizationFromLocal, getRole, namesWithClientIds } from "../utils/utilities";

import Search from "./Search";
import Header from "./Header";
import Loader from "./Loader";
import Error from "./Error";
import Footer from "./Footer";
import InfoModal from "./InfoModal";

const formatCurrencyDolar = number =>
  new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }).format(number);

const getValueTax = (lastTrans, modo) =>{
  switch (modo) {
    case 'Mun':
      return lastTrans.taxMun != null
        ? lastTrans.taxMun
        : lastTrans.TaxMun;
    case 'State':
      return lastTrans.taxState != null
        ? lastTrans.taxState
        : lastTrans.TaxState;
    case 'State Red':
      return lastTrans.taxStateRed != null
        ? lastTrans.taxStateRed
        : lastTrans.TaxStateRed;
    default:
      return 0.0;
  }
}

const PAGE_SIZE = 50;

const filterTrans = (allTrans, query) => {
  let searchResult = [];
  const splittedQuery = query.split('*');

  const clientName = splittedQuery[0];
  const clientId = splittedQuery[1];

  if (query) {
    const match = new RegExp(escapeRegExp(clientName), "i");
    searchResult = allTrans.filter(trans => match.test(trans.storeName));
    if (searchResult.length === 0) {
      searchResult = allTrans.filter(trans => match.test(trans.posId));
    }
    if (clientId && searchResult.length > 0) {
      searchResult = searchResult.filter(client => client.clientId.toString().startsWith(clientId));
    }
  } else {
    searchResult = allTrans;
  }

  return searchResult
    .slice()
    .sort((a, b) => a.posId - b.posId)
    .filter(pos => pos.isTest !== true);
};

const getPageWindow = (currentPage, totalPages, siblingCount = 1) => {
  const totalSlots = siblingCount * 2 + 5;
  if (totalPages <= totalSlots) {
    return Array.from({ length: totalPages }, (_, i) => i + 1);
  }

  const left = Math.max(currentPage - siblingCount, 1);
  const right = Math.min(currentPage + siblingCount, totalPages);
  const showLeftEllipsis = left > 2;
  const showRightEllipsis = right < totalPages - 1;

  const pages = [1];
  if (showLeftEllipsis) pages.push('ellipsis-left');
  for (let p = left; p <= right; p++) {
    if (p !== 1 && p !== totalPages) pages.push(p);
  }
  if (showRightEllipsis) pages.push('ellipsis-right');
  pages.push(totalPages);
  return pages;
};

// ─── Fila aislada: PureComponent hace comparación shallow de props ─────────────
// Solo la fila cuyo isDropdownOpen o isCopied cambie se va a re-renderizar.
class TransRow extends PureComponent {
  render() {
    const { pos, role, isDropdownOpen, isCopied, toggle, onCopy, twoWeeksBack, rowIndex } = this.props;
    return (
      <tr>
        {(role && !role.view_only && (!role.clients || role.clients === '')) && (
          <td className="text-center">{pos.clientId}</td>
        )}
        <td className="text-center">{pos.posId}</td>
        {role && (!role.clients || role.clients === '') && (
          <td className="text-center">{pos.clientName}</td>
        )}
        <td className="text-center">
          {role && (role.client_admin || role.view_only)
            ? pos.storeName.replace("El Meson -", "")
            : pos.storeName}
        </td>
        <td
          className={
            pos.lastInsertedDate === null
              ? "table-warningX2 text-center"
              : new Date(pos.lastInsertedDate) < new Date(twoWeeksBack)
                ? "table-dangerX2 text-center"
                : "table-success text-center"
          }>
          {pos.lastInsertedDate === null ? (
            "Offline"
          ) : (
            <Moment format="MM/D/YY" withTitle className="text-center">
              {pos.lastInsertedDate}
            </Moment>
          )}
        </td>
        <td className="text-center">
          {pos.posName === null || pos.posName === "" ? "-" : pos.posName}
        </td>
        {/* agregado 3/6/2026 */}
        <td
          className={
            pos.expirationDate === null ? "table-warningX2 text-center"
              : new Date(pos.expirationDate) < new Date(twoWeeksBack)
                ? "table-dangerX2 text-center"
                : "table-success text-center"
          }>
          {pos.expirationDate === null ? "-" :
            <Moment format="MM/D/YY" withTitle className="text-center">
              {pos.expirationDate}
            </Moment>
          }
        </td>
        <td className="text-center">
          {pos.lastReportVersion === "null" || pos.lastReportVersion === null
            ? "No version"
            : pos.lastReportVersion}
        </td>
        <td className="text-left">
          {!pos.lastTrans || pos.lastTrans.Control === "null" || pos.lastTrans.Control === null ? (
            <p className="text-center">-</p>
          ) : (
            // <>
            //   <p> Tax Mun: {formatCurrencyDolar(pos.lastTrans.taxMun)}</p>
            //   <p> Tax State: {formatCurrencyDolar(pos.lastTrans.taxState)}</p>
            //   <p> Tax State Red: {formatCurrencyDolar(pos.lastTrans.taxStateRed)}</p>
            //   <p> Control: {pos.lastTrans.Control === "null" || pos.lastTrans.Control === null ? "-" :
            //   <span className='font-weight-bold'> {pos.lastTrans.Control}</span>}</p> 
            // </>
            <Dropdown group isOpen={isDropdownOpen} toggle={() => toggle(rowIndex)}>
              <Button
                color="success"
                size="sm"
                id={`btn-control-${rowIndex}`}
                onClick={() => onCopy(rowIndex, pos.lastTrans.Control)}
              >
                Control:
                <span className="font-weight-bold ml-1">
                  {pos.lastTrans.Control}
                </span>
              </Button>
              <DropdownToggle caret color="success" size="sm" />
              <Tooltip
                isOpen={isCopied}
                target={`btn-control-${rowIndex}`}
                toggle={() => { }}
              >
                Copied: {pos.lastTrans.Control}
              </Tooltip>
              <DropdownMenu right className="p-3" style={{ minWidth: "200px" }}>
                <p><strong>Tax Mun:</strong> {formatCurrencyDolar(getValueTax(pos.lastTrans, 'Mun'))}</p>
                <p><strong>Tax State:</strong> {formatCurrencyDolar(getValueTax(pos.lastTrans, 'State'))}</p>
                <p><strong>Tax State Red:</strong> {formatCurrencyDolar(getValueTax(pos.lastTrans, 'State Red'))}</p>
              </DropdownMenu>
            </Dropdown>
          )}
        </td>
      </tr>
    );
  }
}
// ──────────────────────────────────────────────────────────────────────────────

const PaginationBar = ({ currentPage, totalPages, onPageChange }) => {
  if (totalPages <= 1) return null;

  const pageWindow = getPageWindow(currentPage, totalPages, 1);

  return (
    <Pagination aria-label="Transactions pagination" listClassName="justify-content-center flex-wrap mb-0">
      <PaginationItem disabled={currentPage === 1}>
        <PaginationLink onClick={() => onPageChange(1)}>First</PaginationLink>
      </PaginationItem>
      <PaginationItem disabled={currentPage === 1}>
        <PaginationLink previous onClick={() => onPageChange(currentPage - 1)} />
      </PaginationItem>
      {pageWindow.map(item =>
        typeof item === "number" ? (
          <PaginationItem key={item} active={item === currentPage}>
            <PaginationLink onClick={() => onPageChange(item)}>{item}</PaginationLink>
          </PaginationItem>
        ) : (
          <PaginationItem key={item} disabled>
            <PaginationLink tag="span">&hellip;</PaginationLink>
          </PaginationItem>
        )
      )}
      <PaginationItem disabled={currentPage === totalPages}>
        <PaginationLink next onClick={() => onPageChange(currentPage + 1)} />
      </PaginationItem>
      <PaginationItem disabled={currentPage === totalPages}>
        <PaginationLink onClick={() => onPageChange(totalPages)}>Last</PaginationLink>
      </PaginationItem>
    </Pagination>
  );
};

class TransSummaryTable extends Component {
  state = {
    trans: [],
    filteredTrans: [],
    query: "",
    currentPage: 1,
    error: false,
    loading: false,
    authenticated: this.props.onAuthenticated,
    role: false,
    clientStores: [],
    infoOpen: false,
    infoId: [],
    dropdownOpen: null,
    copiedId: null,
    twoWeeksBack: null,

  };

  copyResetTimer = null;
  tableRef = React.createRef();

  componentDidMount = async () => {

    const authorization = getAuthorizationFromLocal()
    if (!authorization) {
      this.props.history.push("/");
      return
    }

    this.setState({ loading: true });

    const { endpoint } = this.props.match.params;

    const currentEmail = authorization[0].email
    const clients = authorization[0].clients

    getRole(currentEmail)//get auth lvl and role(admin,admin with filters,view-only, superadmin)
      .then((role) => {
        const auth = role && (role.admin || role.super_admin || role.view_only) //If true user have auth to be in transactions page
          ? true
          : false

        this.setState(
          {
            role: role
          },
          async () => {

            if (auth && endpoint !== 'TransSummary' && (clients === '' || !role.clients || role.clients === '')) {
              this.props.history.push("/report/TransSummary");
            }
            if (auth && endpoint !== 'summary' && (clients !== '' || role.clients !== '')) {
              this.props.history.push("/report/summary")
            }

            const request = await getIvuTrans();

            if (request.response && request.response.status !== 200) {
              this.setState({ error: true });
            } else {
              const scopedClientIds = role.clients
                ? role.clients.split(',').map(e => e.trim()).filter(e => e !== '')
                : [];
              const scopedRequest = scopedClientIds.length > 0
                ? request.filter(pos => scopedClientIds.includes(pos.clientId.toString()))
                : request;

              if (!role.clients || role.clients === '') {
                const info = namesWithClientIds(scopedRequest)
                this.setState({ infoId: [...info] })
              }

              this.setState({
                trans: scopedRequest,
                filteredTrans: filterTrans(scopedRequest, this.state.query),
                twoWeeksBack: this.checkDate(14).twoWeeksBack,
                loading: false
               }
              //  Por el momento se descativo el temporizador debido a la llamada a la API de la funcion getIvuTrans suele demorar mas de lo esperado
              //  , () =>
              //   setTimeout(() => this.setState({ loading: false }), 1200)
              );
            }
          })
      })
  };

  componentWillUnmount = () => {
    if (this.copyResetTimer) clearTimeout(this.copyResetTimer);
  };

  checkDate = days => {
    const day = new Date();
    return {
      today: moment(new Date()).format("L"),
      twoWeeksBack: new Date(day.setDate(day.getDate() - days)),
    };
  };

  goToPage = (page, scroll = true) => {
    const totalPages = Math.max(1, Math.ceil(this.state.filteredTrans.length / PAGE_SIZE));
    const nextPage = Math.min(Math.max(1, page), totalPages);
    if (nextPage === this.state.currentPage) return;
    this.setState({ currentPage: nextPage, dropdownOpen: null, copiedId: null }, () => {
      if (scroll && this.tableRef.current) {
        this.tableRef.current.scrollIntoView({ behavior: "smooth", block: "start" });
      }
    });
  };

  updateSearch = rawQuery => {
    const trimmed = rawQuery.trim();
    this.setState({
      query: trimmed,
      filteredTrans: filterTrans(this.state.trans, trimmed),
      currentPage: 1,
      dropdownOpen: null,
      copiedId: null,
    });
  };

  toggle = (id) => {
    const newId = this.state.dropdownOpen === id ? null : id;
    if (newId !== this.state.dropdownOpen) {
      this.setState({ dropdownOpen: newId });
    }
  };

  handleCopy = (index, control) => {
    navigator.clipboard.writeText(control);
    if (this.copyResetTimer) clearTimeout(this.copyResetTimer);
    this.setState({ copiedId: index });
    this.copyResetTimer = setTimeout(() => this.setState({ copiedId: null }), 500);
  };

  render() {
    const { query, filteredTrans, currentPage, loading, error, dropdownOpen, copiedId, twoWeeksBack, role } = this.state;

    const showClientId = role && !role.view_only && (!role.clients || role.clients === '');
    const showClientName = role && (!role.clients || role.clients === '');
    const totalResults = filteredTrans.length;
    const totalPages = Math.max(1, Math.ceil(totalResults / PAGE_SIZE));
    const startIdx = (currentPage - 1) * PAGE_SIZE;
    const pageItems = filteredTrans.slice(startIdx, startIdx + PAGE_SIZE);
    const colSpan = 7 + (showClientId ? 1 : 0) + (showClientName ? 1 : 0);

    const renderPaginationControls = scroll => totalResults > 0 && (
      <div className="d-flex justify-content-between align-items-center flex-wrap mb-1">
        <div className="text-muted">
          Showing {startIdx + 1}&ndash;{Math.min(startIdx + PAGE_SIZE, totalResults)} of {totalResults} results
        </div>
        <PaginationBar
          currentPage={currentPage}
          totalPages={totalPages}
          onPageChange={page => this.goToPage(page, scroll)}
        />
      </div>
    );

    return loading ? (
      <Loader />
    ) : error ? (
      <Error />
    ) : (
      <>
        <Header />
        <Search onUpdateSearch={this.updateSearch} placeholder='Search by Store name' />
        {renderPaginationControls(false)}
        <Table innerRef={this.tableRef} bordered hover className="mt-2 mb-2">
          <thead className="thead-dark text-center ">
            <tr>
              {showClientId && (
                <th scope="row">Client Id  <span className="pointer animate-opacity" onClick={() => { this.setState({ infoOpen: !this.state.infoOpen }) }}><FontAwesomeIcon size="1x" icon={faInfoCircle} /></span></th>
              )}
              <th scope="row">Pos Id</th>
              {showClientName && (
                <th scope="row">Client Name</th>
              )}
              <th scope="row">Store Name</th>
              <th scope="row">Upload</th>
              <th scope="row">Reference</th>
              <th scope="row">Expiration Date</th>
              <th scope="row">Version</th>
              <th scope="row">Last Trans</th>
            </tr>
          </thead>
          <thead className="thead-light text-center">
            <tr>
              {showClientId && (
                <th scope="row" className="min-w-80px">
                  <FontAwesomeIcon size="1x" icon={faUser} />
                </th>)
              }
              <th scope="row">
                <FontAwesomeIcon size="1x" icon={faDesktop} />
              </th>
              {showClientName && (
                <th scope="row">
                  <FontAwesomeIcon size="1x" icon={faIndustry} />
                </th>
              )}
              <th scope="row">
                <FontAwesomeIcon size="1x" icon={faStoreAlt} />
              </th>
              <th scope="row">
                <FontAwesomeIcon size="1x" icon={faUpload} />
              </th>
              <th scope="row">
                <FontAwesomeIcon size="1x" icon={faAsterisk} />
              </th>
              <th scope="row">
                <FontAwesomeIcon size="1x" icon={faCalendar} />
              </th>
              <th scope="row">
                <FontAwesomeIcon size="1x" icon={faBoxes} />
              </th>
              <th scope="row">
                <FontAwesomeIcon size="1x" icon={faUniversity} />
              </th>
            </tr>
          </thead>
          <tbody>
            {pageItems.length > 0 ? (
              pageItems.map((pos, index) => (
                <TransRow
                  key={index}
                  pos={pos}
                  role={role}
                  rowIndex={index}
                  isDropdownOpen={dropdownOpen === index}
                  isCopied={copiedId === index}
                  toggle={this.toggle}
                  onCopy={this.handleCopy}
                  twoWeeksBack={twoWeeksBack}
                />
              ))
            ) : (
              <tr>
                <td colSpan={colSpan} className="text-center py-4">
                  {query ? "No results match your search." : "No transactions to display."}
                </td>
              </tr>
            )}
          </tbody>
        </Table>
        {renderPaginationControls(true)}
        <InfoModal isOpen={this.state.infoOpen} toggle={() => this.setState({ infoOpen: !this.state.infoOpen })}>
          <div className="max-h-500px overflow-y-scroll">
            <Table>
              <thead>
                <tr>
                  <th>ID</th>
                  <th>CLIENT</th>
                </tr>
              </thead>
              <tbody>
                {this.state.infoId.length
                  ? this.state.infoId.map(e => <tr key={e.clientId}>
                    <td>{e.clientId}</td>
                    <td>{e.clientName}</td>
                  </tr>)
                  : <></>
                }

              </tbody>
            </Table>
            <hr></hr>
          </div>
        </InfoModal>
        {!loading && <Footer />}
      </>
    );
  }
}

export default TransSummaryTable;
